import React, { useEffect } from "react";
import MainPage from './MainPage';
import Layout from './Layout';
import PrivacyPage from './PrivacyPage';
import TermsPage from './TermsPage';
import BlogPage from './BlogPage';
import BlogPost from './BlogPost';
import StorePalPage from './StorePalPage';
import ContactPage from './ContactPage';
import ScrollToTop from './ScrollToTop';
import TagManager from 'react-gtm-module';
import { createBrowserRouter, RouterProvider, useLocation } from 'react-router-dom';

// Create a component to handle GTM page tracking
const GTMPageTracker = ({ children }) => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view when route changes
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        page: location.pathname + location.search,
      }
    });
  }, [location]);

  return children;
};

const router = createBrowserRouter([
  // ✅ Main page uses Layout
  {
    element: (
      <>
        <ScrollToTop />
        <GTMPageTracker>
          <Layout />
        </GTMPageTracker>
      </>
    ),
    children: [
      { path: "/", element: <MainPage /> }
    ]
  },

  // Other pages with GTM tracking
  { 
    path: "/privacy", 
    element: (
      <>
        <ScrollToTop />
        <GTMPageTracker>
          <PrivacyPage />
        </GTMPageTracker>
      </>
    ) 
  },
  { 
    path: "/terms", 
    element: (
      <>
        <ScrollToTop />
        <GTMPageTracker>
          <TermsPage />
        </GTMPageTracker>
      </>
    ) 
  },
  { 
    path: "/blog", 
    element: (
      <>
        <ScrollToTop />
        <GTMPageTracker>
          <BlogPage />
        </GTMPageTracker>
      </>
    ) 
  },
  { 
    path: "/blog/:postId", 
    element: (
      <>
        <ScrollToTop />
        <GTMPageTracker>
          <BlogPost />
        </GTMPageTracker>
      </>
    ) 
  },
  {
    path: "/storepal",
    element: (
      <>
        <ScrollToTop />
        <GTMPageTracker>
          <StorePalPage />
        </GTMPageTracker>
      </>
    ),
  },
  {
    path: "/contact",
    element: (
      <>
        <ScrollToTop />
        <GTMPageTracker>
          <ContactPage />
        </GTMPageTracker>
      </>
    ),
  },

  // wildcard fallback
  { 
    path: "*", 
    element: (
      <>
        <ScrollToTop />
        <GTMPageTracker>
          <BlogPage />
        </GTMPageTracker>
      </>
    ) 
  }
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;